import React, { useEffect, useState } from 'react'

import getOptions from './chartOptions'
import Loader from '../../../HighchartsCharts/components/Loader'
import Chart from '../../../../../../Components/Chart'

const BarChart = ({
  title,
  yAxisTitle,
  series,
  tooltipValueSuffix,
  categories,
  footnote,
}) => {
  const [options, setOptions] = useState(null)

  useEffect(() => {
    const newOptions = getOptions({
      title,
      yAxisTitle,
      series,
      tooltipValueSuffix,
      categories,
    })
    setOptions(newOptions)
  }, [title, yAxisTitle, series, tooltipValueSuffix, categories])

  if (!options) return <Loader />
  return (
    <div>
      {/* <Suspense fallback={<Loader />}> */}
      <Chart options={options} />
      {/* </Suspense> */}
      <div
        style={{
          color: '#7c7c7c',
          fontSize: '14px',
          margin: ' -30px 0 40px',
        }}
      >
        {footnote}
      </div>
    </div>
  )
}

export default BarChart
